<template>
  <div class="container">
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.shipmentNumber') + ':'" prop="no">
        <el-input
          v-model.trim="form.no"
          name="shipmentNumber"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.deviceCategory') + ':'" prop="deviceCategory">
        <el-select
          v-model="form.deviceCategory"
          filterable
          multiple
          collapse-tags
          size="small"
          style="width: 180px;">
          <el-option
            v-for="item in categoryTypes"
            :key="item.value"
            :label="item.explain"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.address') + ':'" prop="address">
        <el-input
          v-model.trim="form.address"
          name="address"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 180px;"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.device') + '/' + $t('common.componentName') + ':'" prop="deviceName">
        <el-input
          v-model.trim="form.deviceName"
          name="deviceName"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 180px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.device') + '/' + $t('common.componentModel') + ':'" prop="deviceModel">
        <el-input
          v-model.trim="form.deviceModel"
          name="deviceModel"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 180px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.device') + '/' + $t('common.componentNumber') + ':'" prop="deviceNumber">
        <el-input
          v-model.trim="form.deviceNumber"
          name="deviceNumber"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 180px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.componentSerialNo') + ':'" prop="componentSerialNo">
        <el-input
          v-model.trim="form.deviceSerialNo"
          name="componentSerialNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryDevice">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="control-container">
      <router-link to="/deviceDelivery/create">
        <el-button type="warning" size="small">
          {{$t('device.addNewDeviceDelivery')}}
        </el-button>
      </router-link>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-tabs v-model="scope.row.activeName">
              <el-tab-pane :label="$t('common.device')" name="device"></el-tab-pane>
              <el-tab-pane :label="$t('common.component')" name="component"></el-tab-pane>
            </el-tabs>
            <el-table
              v-show="scope.row.activeName === 'device'"
              ref="table"
              border
              max-height="400"
              :data="scope.row.deviceList"
              :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
              header-cell-class-name="headerCellName"
              row-key="id">
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-table
                    max-height="100%"
                    border
                    key="subDeviceInDevice"
                    :data="scope.row.subDevice"
                    :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
                    :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
                    header-cell-class-name="headerCellName"
                    row-key="id">
                    <el-table-column prop="addr" :label="$t('common.address')"/>
                    <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
                    <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
                    <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
                    <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.productionDate) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
                    <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
                    <el-table-column prop="status" :label="$t('common.status')">
                      <template slot-scope="scope">
                        {{ subDeviceStatusVal(scope.row) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="num" :label="$t('common.count')">
                      <template slot-scope="scope">
                        {{ scope.row.num | toThousandFilter }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="unit" :label="$t('common.unit')">
                    </el-table-column>
                    <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.deviceCategory')">
                <template slot-scope="scope">
                  {{ deviceCategoryVal(scope.row.flag) }}
                </template>
              </el-table-column>
              <el-table-column prop="addr" :label="$t('common.address')"/>
              <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
              <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
              <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
              <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.productionDate) }}
                </template>
              </el-table-column>
              <el-table-column prop="installationDate" :label="$t('common.installDate')">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.installationDate) }}
                </template>
              </el-table-column>
              <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
              <el-table-column :label="$t('common.status')">
                <template slot-scope="scope">
                  {{ deviceStatusVal(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column prop="num" :label="$t('common.count')">
                <template slot-scope="scope">
                  {{ scope.row.num | toThousandFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('common.unit')">
              </el-table-column>
              <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <el-table
              v-show="scope.row.activeName === 'component'"
              max-height="400"
              border
              :data="scope.row.subDeviceList"
              :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
              header-cell-class-name="headerCellName"
              row-key="id">
              <el-table-column prop="addr" :label="$t('common.address')"/>
              <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
              <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
              <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
              <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.productionDate) }}
                </template>
              </el-table-column>
              <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
              <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
              <el-table-column prop="status" :label="$t('common.status')">
                <template slot-scope="scope">
                  {{ subDeviceStatusVal(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column prop="num" :label="$t('common.count')">
                <template slot-scope="scope">
                  {{ scope.row.num | toThousandFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('common.unit')">
              </el-table-column>
              <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="no" :label="$t('common.shipmentNumber')"/>
        <el-table-column :label="$t('common.customerName')">
          <template slot-scope="scope">
            {{scope.row.customer && scope.row.customer.customerName}}
          </template>
        </el-table-column>
        <el-table-column prop="contact" :label="$t('common.contact')"></el-table-column>
        <el-table-column prop="contactPhone" :label="$t('common.contactPhone')"></el-table-column>
        <el-table-column prop="contactAddr" :label="$t('common.address')"></el-table-column>
        <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        <el-table-column :label="$t('common.updateTime')">
          <template slot-scope="scope">
            {{ scope.row.updateAt | toTimeFormatFilter }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.deliveryList')" width="80">
          <template slot-scope="scope">
            <router-link :to='{path: `/delivery-list/${scope.row.id}`}' tag="a" target="_blank">
              <el-button type="text" class="link">
                {{$t('common.print')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operate')" width="120">
          <template slot-scope="scope">
            <router-link :to="'/deviceDelivery/edit/' + scope.row.id">
              <el-button type="text" class="link" >
                {{$t('common.revise')}}
              </el-button>
            </router-link>
            <el-button
              type="text"
              class="link"
              @click="deleteDeviceDelivery(scope.row.id)">
              {{$t('common.delete')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import {
  deviceDeliveryDelete,
  deviceDeliveryList,
} from '@/api/device';
import {
  Pagination,
} from '@/components';
import {defaultCategoryTypes, defaultDeviceStatus, defaultSubDeviceStatus} from "@/utils/defines";
import i18n from "@/lang";
import moment from "moment";

const defaultForm = {
  no: undefined,
  deviceCategory: undefined,
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  deviceSerialNo: undefined,
};
const categoryTypes = {
  ...defaultCategoryTypes,
  100: {
    value: 100,
    explain: i18n.t('common.component'),
  }
};

export default {
  name: "DeviceDeliveryList",
  components: {
    Pagination,
  },
  data() {
    return {
      form: {},
      searchParams: {},
      rules: {},
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      loading: false,
      categoryTypes,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.deviceDeliveryList();
    })
  },
  computed: {
    displayData() {
      return this.listData;
    },
  },
  methods: {
    onChangePage() {
      this.deviceDeliveryList();
    },
    async deviceDeliveryList() {
      const {
        page,
        perpage,
      } = this;
      const {
        deviceCategory,
        no,
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        deviceSerialNo,
      } = this.searchParams;
      this.loading = true;
      let flag = [];
      if (deviceCategory && deviceCategory.length === 1) {
        flag = [deviceCategory[0], deviceCategory[0]];
      } else {
        flag = deviceCategory;
      }
      try {
        const res = await deviceDeliveryList({
          page,
          perpage,
          flag: flag && flag.length > 0 ? flag : undefined,
          no: no || undefined,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        const records = data.records || [];
        this.listData = [];
        let devicesHistories, deviceList, subDeviceList, linkedSubDeviceListObj;
        for (let row of records) {
          devicesHistories = row.devicesHistories;
          linkedSubDeviceListObj = {};
          deviceList = [];
          subDeviceList = [];
          if (devicesHistories) {
            let parentDevId;
            for (let row of devicesHistories) {
              if (row) {
                if (row.flag === 100) {
                  parentDevId = row.parentDevId;
                  if (parentDevId === null) {
                    subDeviceList.push(row);
                  } else {
                    if (!linkedSubDeviceListObj[parentDevId]) {
                      linkedSubDeviceListObj[parentDevId] = [];
                    }
                    linkedSubDeviceListObj[parentDevId].push(row);
                  }
                } else {
                  deviceList.push(row)
                }
              }
            }
            for (let row of deviceList) {
              row.subDevice = linkedSubDeviceListObj[String(row.deviceId)] || [];
            }
          }
          this.listData.push({
            ...row,
            activeName: 'device',
            deviceList,
            subDeviceList,
          });
        }
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.deviceDeliveryList();
    },
    queryDevice() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.deviceDeliveryList();
    },
    deleteDeviceDelivery(id) {
      this.$confirm(this.$t('device.thisActionWillDeleteThisDeviceDelivery'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        try {
          await deviceDeliveryDelete({
            id: id,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.deviceDeliveryList();
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    deviceCategoryVal(flag) {
      const {
        categoryTypes,
      } = this;
      return categoryTypes[flag] ? `${categoryTypes[flag].explain}` : ''
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.el-form {
  padding: 10px 20px 0;
  border-bottom: 1px solid #E5E5E5;
}
.el-form-item {
  margin-bottom: 10px;
}
.control-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin: 10px 20px;
}
.target-container {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  margin: 0 20px;
  height: 100%;
  overflow: auto;
}
.link {
  color: #169BD5;
  padding: 0 5px;
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}
.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
